export default {
      id: "wedo-3-usage",
      viewBox: "0 0 50 50",
      url: "/" + "assets/sprite.svg#wedo-3",
      toString: function () {
        return this.url;
      }
    }